var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#A5A5A8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71683 9.00001H9.46683V8.00001H5.71683V9.00001ZM5.71683 7.50001H12.3002V6.50001H5.71683V7.50001ZM5.71683 6.00001H12.3002V5.00001H5.71683V6.00001ZM4.3335 12.6667C4.06683 12.6667 3.8335 12.5667 3.6335 12.3667C3.4335 12.1667 3.3335 11.9333 3.3335 11.6667V2.33334C3.3335 2.06668 3.4335 1.83334 3.6335 1.63334C3.8335 1.43334 4.06683 1.33334 4.3335 1.33334H13.6668C13.9335 1.33334 14.1668 1.43334 14.3668 1.63334C14.5668 1.83334 14.6668 2.06668 14.6668 2.33334V11.6667C14.6668 11.9333 14.5668 12.1667 14.3668 12.3667C14.1668 12.5667 13.9335 12.6667 13.6668 12.6667H4.3335ZM4.3335 11.6667H13.6668V2.33334H4.3335V11.6667ZM2.3335 14.6667C2.06683 14.6667 1.8335 14.5667 1.6335 14.3667C1.4335 14.1667 1.3335 13.9333 1.3335 13.6667V3.33334H2.3335V13.6667H12.6668V14.6667H2.3335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.d3b93e4a89d08e96f2688854b4aef974.svg";
export { ForwardRef as ReactComponent };